import React from 'react';
import { Link } from 'react-router-dom';
import PayComponent from './PayComponent';

function Footer() {
  return (
    <div>
    <PayComponent />
    <footer style={{ textAlign: 'center', padding: '10px', fontSize: '14px', color: '#333' }}>
      <div style={{
        backgroundColor: '#FFD700',
        padding: '12px',
        borderRadius: '6px',
        marginBottom: '12px',
        lineHeight: 1.6,
      }}>
        <p style={{ margin: '0 0 6px 0', fontWeight: 'bold' }}>このサイトでの広告掲載を受付中です。</p>
        <Link
          to="/contact"
          style={{ color: '#d2691e', textDecoration: 'none', fontWeight: 'bold' }}
        >
          お問い合わせフォームはこちら
        </Link>
        <p style={{ margin: '6px 0 0 0', fontSize: '12px', color: '#666' }}>送信内容は kei@sugano.works に届けられます。</p>
      </div>
      <div style={{ marginBottom: '8px' }}>
        <Link to="/jobs" style={{ color: '#666', textDecoration: 'none', fontSize: '12px' }}>
          Jobs・声優募集
        </Link>
      </div>
      <div style={{ marginBottom: '8px' }}>
        <Link to="/privacy" style={{ color: '#666', textDecoration: 'none', fontSize: '12px' }}>
          プライバシーポリシー
        </Link>
      </div>
      <div style={{ marginBottom: '10px' }}>
        <Link to="/admin" style={{ color: '#666', textDecoration: 'none', fontSize: '12px' }}>
          管理者専用画面
        </Link>
      </div>
      ASMRキリスト教会 all rights reserved.
    </footer>
    </div>
  );
}

export default Footer;
